import { render, staticRenderFns } from "./albumDetail.vue?vue&type=template&id=295b6b68&scoped=true"
import script from "./albumDetail.vue?vue&type=script&lang=js"
export * from "./albumDetail.vue?vue&type=script&lang=js"
import style0 from "./albumDetail.vue?vue&type=style&index=0&id=295b6b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b6b68",
  null
  
)

export default component.exports